import { render, staticRenderFns } from "./UserTradeList.vue?vue&type=template&id=7f5c69ae&scoped=true&"
import script from "./UserTradeList.vue?vue&type=script&lang=js&"
export * from "./UserTradeList.vue?vue&type=script&lang=js&"
import style0 from "./UserTradeList.vue?vue&type=style&index=0&id=7f5c69ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c69ae",
  null
  
)

export default component.exports